import { render, staticRenderFns, recyclableRender, components } from "./order-details.vue?vue&type=template&id=474841e4&scoped=true&"
var renderjs
import script from "./order-details.vue?vue&type=script&lang=js&"
export * from "./order-details.vue?vue&type=script&lang=js&"
import style0 from "./order-details.vue?vue&type=style&index=0&lang=css&"
import style1 from "./order-details.vue?vue&type=style&index=1&id=474841e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../soft/HBuilderX.4.08.2024040127/HBuilderX/plugins/uniapp-cli/node_modules/@dcloudio/vue-cli-plugin-uni/packages/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "474841e4",
  null,
  false,
  components,
  renderjs
)

component.options.__file = "pages/order-details/order-details.vue"
export default component.exports